/**
 * The row tray — list engine v2, "never leave the list to learn one more
 * thing".
 *
 * Expanding a row opens the record's most-wanted context: the quote on a job,
 * the contacts on a property, the payments on an invoice. The v2 plan names
 * different panels for every module, and the obvious way to build that is five
 * bespoke trays — which is five components that drift apart on padding, on
 * what an empty panel says, and on what "loading" looks like.
 *
 * So the *shape* is one thing and the *content* is the area's. An area says
 * "here are three panels of lines"; the client draws panels of lines. A new
 * module gets a tray by writing one query, and it looks like every other tray
 * because there is only one that draws them.
 */
import { z } from 'zod';
/** A line's tone — the same four the rest of the product uses. */
export const TRAY_TONES = ['plain', 'ok', 'warn', 'danger'];
export const trayLine = z.object({
    /** The bold line. */
    text: z.string(),
    /** The 11.5px muted line under it. */
    sub: z.string().optional(),
    /** A right-aligned figure — an amount, a count, a date. */
    value: z.string().optional(),
    tone: z.enum(TRAY_TONES).default('plain'),
    /**
     * Where this line goes when clicked, as an app path.
     *
     * Built on the server because only the server knows the id of the quote
     * behind "Quote Q-1042". It is always an in-app path, never a URL: the tray
     * is not a place to hand the browser somewhere arbitrary.
     */
    href: z.string().optional(),
});
export const trayPanel = z.object({
    label: z.string(),
    lines: z.array(trayLine).default([]),
    /** What the panel says when it has nothing — never a blank box. */
    empty: z.string().default('None'),
    /** A headline figure for the panel, drawn beside its label. */
    value: z.string().optional(),
});
export const trayPayload = z.object({
    panels: z.array(trayPanel).default([]),
});
//# sourceMappingURL=list-tray.js.map